/*eslint-disable prettier/prettier*/
import type { IContentAreaItem, IPage, IContent, IImage } from "@/shared/thorlabs/shared";

export type WorkableJobLocationType = {
  country: string;
  countryCode: string;
  city: string;
  region: string;
  hidden: boolean;
};

export type WorkableJobModelType = {
  title: string;
  shortcode: string;
  code: string;
  employment_type: string;
  telecommuting: boolean;
  department: string;
  url: string;
  shortlink: string;
  application_url: string;
  published_on: string; // ISO date string
  created_at: string; // ISO date string
  country: string;
  city: string;
  state: string;
  education: string | undefined;
  experience: string | undefined;
  function: string | undefined;
  industry: string | undefined;
  locations: WorkableJobLocationType[];
};

export type WorkableResponseModelType = {
  name: string;
  description: string;
  jobs: WorkableJobModelType[];
};

export type JobOpportunityType = {
  code: string;
  shortcode: string;
  title: string;
  department: string | undefined;
  employmentType: string | undefined;
  locationString: string | undefined;
  country: string | undefined;
  state: string | undefined;
  city: string | undefined;
  url: string;
  jobSource: JobSource;
};

/**
 * Used for the location dropdown filter in the job listing page.
 */
export type JobLocationItemType = {
  label: string;
  value: string;
  country: string;
  state?: string;
  urlSegment?: string;
  permalink?: string;
  contentLinkId?: number;
};

export interface ICareersHomePage extends IPage {
  title: string;
  headline: string;
  heroImage: IImage;
  summary: string;
  bodyContent: IContentAreaItem<IContent>[];
  breadcrumb: [string, string][];
}

export interface ICareersLocationPage extends IPage {
  title: string;
  heroImage: IImage;
  locationDescription: string;
  benefitsDescription: string;
  locationBenefits: IContentAreaItem<IContent>[];
  //benefits: JobLocationBenefitType[];
  country: string;
  state: string;
  isVisibleOnWebsite?: boolean | null;
  navigationOrder?: number;
  breadcrumb: [string, string][];
}

export type CareersLocationModelType = {
  page: ICareersLocationPage;
  country: string;
  state: string;
  key: string;
  label: string;
  permalink: string;
  navigationOrder: number;
};

export type JobLocationBenefitType = {
  title: string;
  icon: IImage;
};


export enum JobSource
{
    Workable = "Workable",
    Database = "Database",
}

export interface ICareersJobPostingPage extends IPage {
  title: string;
  active: boolean;
  availableDate: Date;
  location: string;
  description: string;
  requirements: string;
  knowledgeAndSkills: string;
  contactName: string;
  contactEmail: string;
  jobID: number;
  permalink: string;
}

export interface IJobLocationModel{
  country?: string;
  state?: string;
  label?: string;
  urlSegment?: string;
  permalink?: string;
  contentLinkId?: number;
}
